var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuetify-wrapper" },
    [
      _c(
        "v-row",
        {
          staticClass: "v-application v-application--is-ltr m-0",
          attrs: { elevation: "1" },
        },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-tabs",
                {
                  attrs: { "show-arrows": "" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c("v-tab", [_vm._v("Apo favorisieren FB")]),
                  _vm._v(" "),
                  _c("v-tab", [_vm._v("FBs Favoriten")]),
                  _vm._v(" "),
                  _c("v-tab", [_vm._v("auf Negativliste von Apos")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  staticClass: "mt-3",
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c("pharmacists-favorites-tab-item", {
                    attrs: {
                      items: _vm.favoritedByPharmacies,
                      loading: _vm.loading,
                      "empty-text": "Keine Einträge",
                      "mutual-ids": _vm.mutualIds,
                    },
                  }),
                  _vm._v(" "),
                  _c("pharmacists-favorites-tab-item", {
                    attrs: {
                      items: _vm.favoritesByPharmacist,
                      loading: _vm.loading,
                      "empty-text": "Keine Favoriten vorhanden",
                      "mutual-ids": _vm.mutualIds,
                    },
                  }),
                  _vm._v(" "),
                  _c("pharmacists-favorites-tab-item", {
                    attrs: {
                      items: _vm.blacklistedByPharmacies,
                      loading: _vm.loading,
                      "empty-text": "Keine Favoriten vorhanden",
                      "mutual-ids": _vm.mutualIds,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }